import { MenuItem, FormControl, InputLabel, Select } from '@mui/material';
import React, { FC, useState } from 'react';

interface YearQuarterDropdownProps {
  pastYears: number;
  onDateSelect: (selectedDate: string) => void;
}

const YearQuarterDropdown: FC<YearQuarterDropdownProps> = ({ pastYears, onDateSelect }) => {
  const currentYear = new Date().getFullYear();
  const currentQuarter = Math.ceil((new Date().getMonth() + 1) / 3);

  const [selectedYear, setSelectedYear] = useState<number>(currentYear);
  const [selectedQuarter, setSelectedQuarter] = useState<number>(currentQuarter);

  const quarters = [1, 2, 3, 4];

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value as number);
    handleDateSelect(event.target.value, selectedQuarter);
  };

  const handleQuarterChange = (event) => {
    setSelectedQuarter(event.target.value as number);
    handleDateSelect(selectedYear, event.target.value);
  };

  const getQuarter = (): number => {
    const month = new Date().getMonth() + 1;
    return Math.ceil(month / 3);
  };

  const formatDate = (year: number, quarter: number): string => {
    const month = quarter === 1 ? 1 : quarter === 2 ? 4 : quarter === 3 ? 7 : 10;
    return `${String(month).padStart(2, '0')}-03-${year}`;
  };

  const handleDateSelect = (year: number, quarter: number) => {
    if (year && quarter) {
      const formattedDate = formatDate(year, quarter);
      onDateSelect(formattedDate);
    }
  };

  return (
    <>
      <FormControl sx={{ margin: 1, minWidth: 120 }}>
        <InputLabel id="year-label">Year</InputLabel>
        <Select
          labelId="year-label"
          id="year-select"
          value={selectedYear}
          onChange={handleYearChange}
          label="Year"
        >
          {Array.from(
            { length: pastYears * 2 + 1 },
            (_, index) => currentYear - pastYears + index
          ).map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {selectedYear && (
        <FormControl sx={{ margin: 1, minWidth: 120 }}>
          <InputLabel id="quarter-label">Quarter</InputLabel>
          <Select
            labelId="quarter-label"
            id="quarter-select"
            value={selectedQuarter}
            onChange={handleQuarterChange}
            label="Quarter"
          >
            {quarters.map((quarter) => {
              const isDisabled = currentYear === selectedYear && quarter > getQuarter();
              return (
                <MenuItem key={quarter} value={quarter} disabled={isDisabled}>
                  {`Q${quarter}`}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
    </>
  );
};

export default YearQuarterDropdown;
